// Query-key factory for the /api/v1/tenants/me resource. Kept distinct
// from `meKeys` because tenant settings and the user profile are
// independent caches -- updating one shouldn't invalidate the other.
export const tenantKeys = {
  all: ['tenant'] as const,
  current: () => [...tenantKeys.all, 'current'] as const,
};
